import dynamic from 'next/dynamic';

export const ReviewFormDynamic = dynamic(() => import('./ReviewForm'));
